export default __webpack_public_path__ + "static/media/36.8332c4f0.jpg";